import { render, staticRenderFns } from "./IconSettings.vue?vue&type=template&id=0ae53b6f&"
import script from "./IconSettings.vue?vue&type=script&lang=js&"
export * from "./IconSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports